<template>
  <section class="sec-3">
    <header
      class="sec-home-titr"
      ref="sec3header"
    >
      <h2 class="sec-home-titr__title" :class="{ 'active': showSection3Title }">چگونه عسل تولید میشود ؟</h2>
    </header>
    <main class="sec-3-main">
      <section class="produce-descrip">
        <div class="produce-descrip__video">
          <div class="produce-descrip__video-controls" @click="videoControl">
            <div
              class="produce-descrip__video-control produce-descrip__video-control-play"
              v-show="!isPlaying"
            >
              <i class="fas fa-play"></i>
            </div>
            <div
              class="produce-descrip__video-control produce-descrip__video-control-pause"
              v-show="isPlaying"
            >
              <i class="fas fa-pause"></i>
            </div>
          </div>
          <video
            src="../../public/video/Bee.mp4"
            ref="video"
            loop
            poster="../../public/image/video-photo.jpg"
          ></video>
        </div>
        <div
          class="produce-descrip__text"
          ref="text"
          :class="{ active: showTextBox }"
        >
          <img src="../../public/image/honey-splash.png" />
          <h3>
            تهیه عسل فرایندی پیچیده و منحصر به فرد است و در چند مرحله تولید
            میشود
          </h3>
          <p>
            زنبور عسل این کار را با گرد آوری شهد گل ها در کندو انجام می دهد . در
            زبان فارسی به زنبور عسل منگ ، منج و مگس انگبین نیز گفته می شود .
            زنبور برای تهیه ی عسل شهد گل های مختلفی را جمع آوری می کند . افراد
            بسیاری تصور می کنند که عسل مدفوع زنبور است درصورتی که کاملا اشتباه
            است .
          </p>
          <router-link class="base-btn-2" to="/produce"
            ><i class="fas fa-arrow-right"></i>بیشتر</router-link
          >
        </div>
      </section>
      <section class="produce-level">
        <div class="produce-level__item-1 produce-level__item">
          <header><img src="../../public/image/produce-1.png" /></header>
          <main>
            <h4>
              <span>1</span>گل ها شهد تولید میکنند و زنبور هارا جذب خود میکنند
            </h4>
          </main>
        </div>
        <div class="produce-level__item-2 produce-level__item">
          <header><img src="../../public/image/produce-2.png" /></header>
          <main>
            <h4>
              <span>2</span>زنبور ها شهد را جمع آوری کرده و به کندو می برند
            </h4>
          </main>
        </div>
        <div class="produce-level__item-3 produce-level__item">
          <header><img src="../../public/image/produce-3.png" /></header>
          <main>
            <h4>
              <span>3</span>زنبور ها سلول ها را با موم می بندند و عسل تولید
              میشود
            </h4>
          </main>
        </div>
        <div class="produce-level__item-4 produce-level__item">
          <header><img src="../../public/image/produce-4.png" /></header>
          <main>
            <h4>
              <span>4</span>ما محصول را جمع آوری کرده و به بسته بندی منتقل
              میکنیم
            </h4>
          </main>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
export default {
  data() {
    return {
      showTextBox: false,
      isPlaying: false,
      showSection3Title: false,
    };
  },
  methods: {
    videoControl() {
      this.isPlaying = !this.isPlaying;
      let video = this.$refs.video;
      if (this.isPlaying === false) {
        video.pause();
      } else {
        video.play();
      }
    },
  },
  mounted() {
    let textBox = this.$refs.text;
    let sec3header = this.$refs.sec3header;
    let vh = (window.innerHeight * 2.2) / 4;
    let vhH2=window.innerHeight * 4 / 5;
    window.addEventListener("scroll", () => {
      let topOfTextBox = textBox.getBoundingClientRect().top;
      let topSec3header = sec3header.getBoundingClientRect().top;

      if (topOfTextBox < vh) {
        this.showTextBox = true;
      }
      if (topSec3header < vhH2) {
        this.showSection3Title = true;
      }
    });
  },
};
</script>

<style></style>
